import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';
import { ErrorBoundary } from 'bernie-view';

import { PropertyInfoSectionViewModel } from 'src/common/models';

import { classNames } from 'uitk-react-utils';
import { UitkCard, UitkCardContent } from 'uitk-react-cards';

import { PropertyInfoSection } from 'components/infosite/property-information/property-info-section/index';

export interface AboutThisPropertyCardProps {
  analytics?: AnalyticsStore;
  propertyDesc?: PropertyInfoSectionViewModel;
  propertyAllIncl?: PropertyInfoSectionViewModel;
  awardsAndAffil?: PropertyInfoSectionViewModel;
  propertyManager?: PropertyInfoSectionViewModel;
  propertyStructure?: PropertyInfoSectionViewModel;
}

export const AboutThisPropertyCard: React.FunctionComponent<AboutThisPropertyCardProps> = ({
  analytics,
  propertyDesc,
  propertyAllIncl,
  awardsAndAffil,
  propertyManager,
  propertyStructure
}) => {
  if (!propertyDesc && !propertyStructure && !propertyAllIncl && !awardsAndAffil && !propertyManager) {
    return null;
  }

  const cardClassName = classNames(
    's-y-padding-three',
    's-y-padding-three',
    'm-y-padding-three',
    'all-x-padding-three',
    'l-y-margin-three',
    'l-b-padding-three',
    'xl-y-margin-three',
    'xl-b-padding-three'
  );

  return (
    <ErrorBoundary label="about-property-card">
      <div className="s-b-padding-three m-b-padding-three">
        <UitkCard className={cardClassName}>
          <UitkCardContent>
            <PropertyInfoSection
              analytics={analytics}
              propertyInfoSection={propertyDesc}
              movePropertyTitle={false}
              isToggleHidden={false}
            />
            <PropertyInfoSection analytics={analytics} propertyInfoSection={propertyStructure} subSectionTagLevel={4} />
            <PropertyInfoSection analytics={analytics} propertyInfoSection={propertyAllIncl} subSectionTagLevel={4} isToggleHidden={true} />
            <PropertyInfoSection analytics={analytics} propertyInfoSection={awardsAndAffil} subSectionTagLevel={3} />
            <PropertyInfoSection analytics={analytics} propertyInfoSection={propertyManager} subSectionTagLevel={3} />
          </UitkCardContent>
        </UitkCard>
      </div>
    </ErrorBoundary>
  );
};

AboutThisPropertyCard.displayName = 'AboutThisPropertyCard';
